const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var Health24 = function Health24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      d: "M13.14 18.924a1.504 1.504 0 0 0 1.575 1.575 8.785 8.785 0 0 0 5.848-2.575 8.785 8.785 0 0 0 2.574-5.848 1.504 1.504 0 0 0-1.575-1.575 8.785 8.785 0 0 0-5.848 2.575 8.785 8.785 0 0 0-2.574 5.848ZM9.562 20.498a1.504 1.504 0 0 0 1.575-1.574 8.785 8.785 0 0 0-2.574-5.848A8.785 8.785 0 0 0 2.715 10.5a1.504 1.504 0 0 0-1.575 1.575 8.785 8.785 0 0 0 2.574 5.848A8.785 8.785 0 0 0 9.562 20.5Z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M8.17 10.203c.64.412 1.247.898 1.807 1.458a10.798 10.798 0 0 1 2.162 3.086 10.795 10.795 0 0 1 2.16-3.086c.576-.575 1.2-1.072 1.86-1.49-.086-2.363-1.092-4.508-2.695-6.136a1.844 1.844 0 0 0-2.598 0c-1.61 1.636-2.619 3.793-2.696 6.168Z",
      clipRule: "evenodd",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      d: "M4.696 4.585c.89.28 1.739.7 2.51 1.247a10.98 10.98 0 0 0-.967 3.39 10.83 10.83 0 0 0-3.437-.719 3.605 3.605 0 0 0-.252-.002 9.013 9.013 0 0 1 .177-2.78 1.535 1.535 0 0 1 1.969-1.136ZM18.088 9.203a10.831 10.831 0 0 1 3.523-.703 9.014 9.014 0 0 0-.177-2.769 1.535 1.535 0 0 0-1.97-1.137 9.015 9.015 0 0 0-2.378 1.157c.512 1.07.858 2.23 1.002 3.452Z",
    })
  );
};
Health24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24",
};
const sizeMap = {
  24: Health24,
};
export function Health(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'Health' icon. Please use one of the available sizes: '24'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
